import React from "react";
import {
  Box,
  Paper,
  Stack,
  StepContent,
  Typography,
  Step,
  StepLabel,
  Stepper,
  Button,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const steps = [
  {
    label: "Select campaign settings",
    description: `For each ad campaign that you create, you can control how much
              you're willing to spend on clicks and conversions, which networks
              and geographical locations you want your ads to show on, and more.`,
  },
  {
    label: "Create an ad group",
    description:
      "An ad group contains one or more ads which target a shared set of keywords.",
  },
  {
    label: "Create an ad",
    description: `Try out different ad text to see what brings in the most customers,
              and learn how to enhance your ads using features like ad extensions.
              If you run into any problems with your ads, find out how to tell if
              they're running and how to resolve approval issues.`,
  },
];

const VerticalStepper = () => {
  const [activeStep, setActiveStep] = React.useState(0);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Vertical stepper
        </Typography>
        <Typography variant={"body1"} color={"text.primary"}>
          Vertical steppers are designed for narrow screen sizes. They are ideal
          for mobile. All the features of the horizontal stepper can be
          implemented.
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box mb={3}>
          <PreviewAndEditor
            language={"js"}
            value={
              "" +
              "  const steps = [\n" +
              "    {\n" +
              '      label: "Select campaign settings",\n' +
              "      description: `For each ad campaign that you create, you can control how much\n" +
              "              you're willing to spend on clicks and conversions, which networks\n" +
              "              and geographical locations you want your ads to show on, and more.`,\n" +
              "    },\n" +
              "    {\n" +
              '      label: "Create an ad group",\n' +
              "      description:\n" +
              '          "An ad group contains one or more ads which target a shared set of keywords.",\n' +
              "    },\n" +
              "    {\n" +
              '      label: "Create an ad",\n' +
              "      description: `Try out different ad text to see what brings in the most customers,\n" +
              "              and learn how to enhance your ads using features like ad extensions.\n" +
              "              If you run into any problems with your ads, find out how to tell if\n" +
              "              they're running and how to resolve approval issues.`,\n" +
              "    },\n" +
              "  ];\n" +
              "  \n" +
              "  const [activeStep, setActiveStep] = React.useState(0);\n" +
              "\n" +
              "  const handleNext = () => {\n" +
              "    setActiveStep((prevActiveStep) => prevActiveStep + 1);\n" +
              "  };\n" +
              "\n" +
              "  const handleBack = () => {\n" +
              "    setActiveStep((prevActiveStep) => prevActiveStep - 1);\n" +
              "  };\n" +
              "\n" +
              "  const handleReset = () => {\n" +
              "    setActiveStep(0);\n" +
              "  };" +
              '              <Stepper activeStep={activeStep} orientation="vertical">\n' +
              "                {steps.map((step, index) => (\n" +
              "                  <Step key={step.label}>\n" +
              "                    <StepLabel\n" +
              "                      optional={\n" +
              "                        index === 2 ? (\n" +
              '                          <Typography variant="caption">Last step</Typography>\n' +
              "                        ) : null\n" +
              "                      }\n" +
              "                    >\n" +
              "                      {step.label}\n" +
              "                    </StepLabel>\n" +
              "                    <StepContent>\n" +
              "                      <Typography>{step.description}</Typography>\n" +
              "                      <Box sx={{ mb: 2 }}>\n" +
              "                        <div>\n" +
              "                          <Button\n" +
              '                            variant="contained"\n' +
              "                            onClick={handleNext}\n" +
              "                            sx={{ mt: 1, mr: 1 }}\n" +
              "                          >\n" +
              '                            {index === steps.length - 1 ? "Finish" : "Continue"}\n' +
              "                          </Button>\n" +
              "                          <Button\n" +
              "                            disabled={index === 0}\n" +
              "                            onClick={handleBack}\n" +
              "                            sx={{ mt: 1, mr: 1 }}\n" +
              "                          >\n" +
              "                            Back\n" +
              "                          </Button>\n" +
              "                        </div>\n" +
              "                      </Box>\n" +
              "                    </StepContent>\n" +
              "                  </Step>\n" +
              "                ))}\n" +
              "              </Stepper>\n" +
              "              {activeStep === steps.length && (\n" +
              "                <Paper square elevation={0} sx={{ p: 3 }}>\n" +
              "                  <Typography>\n" +
              "                    All steps completed - you&apos;re finished\n" +
              "                  </Typography>\n" +
              "                  <Button onClick={handleReset} sx={{ mt: 1, mr: 1 }}>\n" +
              "                    Reset\n" +
              "                  </Button>\n" +
              "                </Paper>\n" +
              "              )}"
            }
          >
            <Box sx={{ maxWidth: 400 }}>
              <Stepper activeStep={activeStep} orientation="vertical">
                {steps.map((step, index) => (
                  <Step key={step.label}>
                    <StepLabel
                      optional={
                        index === 2 ? (
                          <Typography variant="caption">Last step</Typography>
                        ) : null
                      }
                    >
                      {step.label}
                    </StepLabel>
                    <StepContent>
                      <Typography>{step.description}</Typography>
                      <Box sx={{ mb: 2 }}>
                        <div>
                          <Button
                            variant="contained"
                            onClick={handleNext}
                            sx={{ mt: 1, mr: 1 }}
                          >
                            {index === steps.length - 1 ? "Finish" : "Continue"}
                          </Button>
                          <Button
                            disabled={index === 0}
                            onClick={handleBack}
                            sx={{ mt: 1, mr: 1 }}
                          >
                            Back
                          </Button>
                        </div>
                      </Box>
                    </StepContent>
                  </Step>
                ))}
              </Stepper>
              {activeStep === steps.length && (
                <Paper square elevation={0} sx={{ p: 3 }}>
                  <Typography>
                    All steps completed - you&apos;re finished
                  </Typography>
                  <Button onClick={handleReset} sx={{ mt: 1, mr: 1 }}>
                    Reset
                  </Button>
                </Paper>
              )}
            </Box>
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default VerticalStepper;
